import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Pricing.css';
import lock from '../assets/lockk.png'



const Pricing = () => {
  const navigate = useNavigate();
  const priceIds = {
    basic: 'price_1RYu5VRqME9GFvRtugxo6aNY', 
    pro: 'price_1RYtvTRqME9GFvRtD4oRfCyS', 
  };
  const handleSubscribe = async(plan) => {
  // to get the token after user logs in
  const authToken = localStorage.getItem('token');

  // If the user isn't logged in at all, you can stop them right away.
    if (!authToken) {
      window.alert('Please log in or sign up to make a purchase.');
      navigate('/login'); // Redirect them to the login page
      return;
    }

    try {
      const response = await fetch('http://localhost:8080/api/create-checkout-session', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authToken}` // Send the user's token for verification
        },
        body: JSON.stringify({ priceId: priceIds[plan] })
      });

      const data = await response.json();

      if (response.ok) {
        // If the server gives a URL, redirect the user to Stripe for payment.
        window.location.href = data.url;
      } else {
        // If the server returns an error (e.g., user not verified), show it.
        window.alert(data.error);
      }
    } catch (error) {
      console.error('Subscription error:', error);
      window.alert('An unexpected error occurred. Please try again.');
    }
};

  return (
    <div className="pricing-page">
      <div className="pricing-header bg-gradient">
        <div className="container">
          <h1>Choose Your Plan</h1>
          <p>Select the best option for your interview preparation needs</p>
        </div>
      </div>

      <div className="container">
        <div className="pricing-cards">
          <div className="pricing-card-basic">
            <div className="card-header">
              <h3>Free Trial</h3>
              <div className="price">
                <span className="amount">$0</span>
                <span className="period">/month</span>
              </div>
            </div>
            <div className="card-body">
              <ul className="features-list">
                <li>1 free practice interview</li>
                <li>Basic feedback analysis</li>
                <li>Flexible Usage – No Credit Card Needed</li>
              </ul>
              <button className="subscribe-button-basic" onClick={() =>navigate('/interview-config') }>
                Get Started
              </button>
            </div>
          </div>
          
          <div className="pricing-card featured">
            <div className="card-header">
              <h3>Basic</h3>
              <div className="price">
                <span className="amount">$4.99</span>
                <span className="period">/month</span>
              </div>
            </div>
            <div className="card-body">
              <ul className="features-list">
                <li>Unlimited practice interviews</li>
                <li>Detailed feedback and scoring</li>
                <li>Voice interface capabilities</li>
                <li>Different case types and industries</li>
              </ul>
              <button className="subscribe-button" onClick={() => handleSubscribe('basic')}>
              <img src= {lock} style={{ width: '20px', marginRight: '8px' }} />
                Get Started
              </button>
            </div>
          </div>

          <div className="pricing-card-enterprise">
            <div className="card-header">
              <h3>Professional</h3>
              <div className="price">
                <span className="amount">$9.99</span>
                <span className="period">/month</span>
              </div>
            </div>
            <div className="card-body">
              <ul className="features-list">
                <li>Everything in Professional plan</li>
                <li>Team management dashboard</li>
                <li>Custom case libraries</li>
                <li>Dedicated account manager</li>
                <li>API access</li>
              </ul>
              <button className="subscribe-button" onClick={() => handleSubscribe('pro')}>
                Contact Sales
              </button>
            </div>
          </div>
        </div>

        <div className="pricing-guarantee">
          <h3>100% Satisfaction Guarantee</h3>
          <p>Try risk-free with one free interview using our AI case interviewer. If you're not completely satisfied, just let us know—no payment required.</p>
        </div>
      </div>
    </div>
  );
};

export default Pricing; 